// src/components/UpgradeCelebration.js
// Full-screen "you just unlocked..." moment shown when a member's tier goes up.
import { gainedFeatures, TIER_LABEL, TIER_TAGLINE } from '../lib/tierFeatures'
import './UpgradeCelebration.css'

// Fixed set of sparkles (positions/timings are static so it never re-randomizes on re-render)
const SPARKLES = [
  { left: '8%',  delay: '0s',   dur: '4.2s', size: 14 },
  { left: '18%', delay: '0.6s', dur: '5s',   size: 10 },
  { left: '28%', delay: '1.2s', dur: '4.6s', size: 16 },
  { left: '40%', delay: '0.3s', dur: '5.4s', size: 12 },
  { left: '52%', delay: '1.6s', dur: '4.4s', size: 18 },
  { left: '63%', delay: '0.9s', dur: '5.2s', size: 11 },
  { left: '74%', delay: '0.2s', dur: '4.8s', size: 15 },
  { left: '85%', delay: '1.4s', dur: '4.3s', size: 12 },
  { left: '93%', delay: '0.7s', dur: '5.1s', size: 16 },
]

export default function UpgradeCelebration({ fromTier, toTier, name, onClose }) {
  const gains = gainedFeatures(fromTier, toTier)
  const label = TIER_LABEL[toTier] || toTier

  return (
    <div className="upgrade-celebration" onClick={onClose} role="dialog" aria-modal="true">
      {SPARKLES.map((s, i) => (
        <span
          key={i}
          className="upgrade-celebration__sparkle"
          style={{ left: s.left, animationDelay: s.delay, animationDuration: s.dur, fontSize: s.size }}
          aria-hidden="true"
        >✦</span>
      ))}

      <div className="upgrade-celebration__card" onClick={e => e.stopPropagation()}>
        <p className="upgrade-celebration__eyebrow">
          {name ? `Congratulations, ${name}` : 'Congratulations'}
        </p>
        <h2 className="upgrade-celebration__title">
          Welcome to <span className={`upgrade-celebration__tier upgrade-celebration__tier--${toTier}`}>{label}</span>
        </h2>
        <p className="upgrade-celebration__tagline">{TIER_TAGLINE[toTier]}</p>

        {gains.length > 0 && (
          <div className="upgrade-celebration__list">
            <p className="upgrade-celebration__list-label">Now unlocked for you</p>
            {gains.map(g => (
              <div key={g.label} className="upgrade-celebration__item">
                <span className="upgrade-celebration__check">✦</span>
                <div>
                  <p className="upgrade-celebration__item-label">{g.label}</p>
                  <p className="upgrade-celebration__item-detail">{g.detail}</p>
                </div>
              </div>
            ))}
          </div>
        )}

        <button className="btn btn--gold upgrade-celebration__btn" onClick={onClose}>
          Explore my new access
        </button>
      </div>
    </div>
  )
}
